import Zad5Scene from "./scene";

export default function TravelersTestPage() {
    return <>
        <h1>TO JEST TYLKO TEST!</h1>
        <Zad5Scene onComplete={() => {}} />
    </>
}
